import { db } from './firebase';
//EMPLOYEES API
export const addEmployee = (values) => db.ref('employees').push(values);

export const getEmployees = () =>
  db
    .ref('employees')
    .orderByChild('isDeleted')
    .equalTo(false)
    .once('value');

export const deleteEmployeeById = (id, value) =>
  db.ref('employees/' + id).update(value);

export const filterEmployeeById = (value) =>
  db.ref('employees/' + value).once('value');

export const updateEmployee = (id, value) =>
  db.ref('employees/' + id).update(value);

export const filterEmployeeByName = (value) =>
  db
    .ref('employees')
    .orderByChild('isDeleted_name')
    .startAt(value)
    .endAt(value + '\uf8ff')
    .once('value');

//Agents API

export const addAgent = (values) => db.ref('agents').push(values);

export const getAgents = () =>
  db
    .ref('agents')
    .orderByChild('isDeleted')
    .equalTo(false)
    .once('value');

export const filterAgentByName = (value) =>
  db
    .ref('agents')
    .orderByChild('isDeleted_name')
    .startAt(value)
    .endAt(value + '\uf8ff')
    .once('value');

export const deleteAgentById = (id, value) =>
  db.ref('agents/' + id).update(value);

export const updateAgent = (id, values) =>
  db.ref('agents/' + id).update(values);

export const getAgentById = (id) =>
  db
    .ref('users')
    .orderByChild('agent/id')
    .equalTo(id)
    .once('value');

export const updateAgentInCustomer = (id, value) =>
  db.ref('users/' + id).update(value);

//USER API
export const getUsers = () =>
  db
    .ref('users')
    .orderByChild('isDeleted')
    .equalTo(false)
    .once('value');

export const filterUserByName = (value) =>
  db
    .ref('users')
    .orderByChild('isDeleted_name')
    .startAt(value)
    .endAt(value + '\uf8ff')
    .once('value');

export const filterUserByStatus = (value) =>
  db
    .ref('users')
    .orderByChild('isDeleted_status')
    .equalTo(value)
    .once('value');

export const addUser = (values) =>
  db
    .ref('users')
    .push(values)
    .then((snapShot) => {
      let customer = {
        id: snapShot.key,
        name: values.name,
        commission: values.agent.commission
      };
      let agentId = values.agent.id;
      db.ref('agents/' + agentId + '/customer')
        .child(snapShot.key)
        .set(customer);
      return snapShot;
    });

export const deleteUserById = (id, value) =>
  db.ref('users/' + id).update(value);

export const updateUser = (userId, values, oldValues) =>
  db
    .ref('users/' + userId)
    .update(values)
    .then(() => {
      let customer = {
        id: userId,
        name: values.name,
        commission: values.agent.commission
      };
      let agentId = values.agent.id;
      db.ref('agents/' + agentId + '/customer')
        .child(userId)
        .set(customer);
      if (values.agent.id !== oldValues.agent.id) {
        db.ref('agents/' + oldValues.agent.id + '/customer')
          .child(userId)
          .remove();
      }
    });

export const updateUserById = (userId, value) =>
  db.ref('users/' + userId).update(value);

//CHITS API
export const addChits = (values) => db.ref('chits').push(values);

export const getChits = () => db.ref('chits').once('value');

//CHITTIES API
export const addChitties = (values) => db.ref('chitties').push(values);

export const getChitties = (chitId) =>
  db
    .ref('chitties')
    .orderByChild('chitId')
    .equalTo(chitId)
    .once('value');

export const updateChitty = (chittyId, value) =>
  db.ref('chitties/' + chittyId).update(value);

export const filterChitties = (value) =>
  db
    .ref('chitties')
    .orderByChild('chitId_chittyName')
    .startAt(value)
    .endAt(value + '\uf8ff')
    .once('value');

export const sortChitties = (value) =>
  db
    .ref('chitties')
    .orderByChild('chitId_status')
    .equalTo(value)
    .once('value');

export const getAllChitties = () => db.ref('chitties').once('value');

//CHITTIES USER API

export const addChittieUsers = (id, values) =>
  db.ref('chitties/' + id).update(values);

export const replaceChittyUser = (id, newUserKey, newUserValue, oldUserKey, oldUserValue) =>
  db
    .ref('chitties/' + id + '/chittieUsers')
    .child(newUserKey)
    .set(newUserValue)
    .then(() => {
      db
        .ref('chitties/' + id + '/replacedUsers/' + oldUserKey)
        .set(oldUserValue).then(() => {
          db
            .ref('chitties/' + id + '/chittieUsers')
            .child(oldUserKey)
            .remove();
        });
    });

export const addChittieAuction = (values) =>
  db
    .ref('chittieAuction')
    .push(values)
    .then((snapshot) => {
      return { [snapshot.key]: values };
    });

export const getChittieAuction = (chittieId) =>
  db
    .ref('chittieAuction')
    .orderByChild('chittieId')
    .equalTo(chittieId)
    .once('value');

export const addAuctionPayment = (auctionId, values) =>
  db.ref('chittieAuction/' + auctionId).update(values);

export const updateAuction = (auctionId, values) =>
  db.ref('chittieAuction/' + auctionId).update(values);

export const addChittiePayment = (values) =>
  db.ref('chittiePayments').push(values);

export const getChittiePayments = () => db.ref('chittiePayments').once('value');

export const updateChittiePayment = (id, values) =>
  db.ref('chittiePayments/' + id).update(values);

export const getChittiePaymentsById = (id) =>
  db
    .ref('chittiePayments')
    .orderByChild('chitId_chittieId')
    .equalTo(id)
    .once('value');

export const fetchChittiePaymentsByUserId = (userId) =>
  db
    .ref('chittiePayments')
    .orderByChild('customerId')
    .equalTo(userId)
    .once('value');

export const getChittiesById = (id) =>
  db
    .ref('chitties/' + id)
    .once('value');

export const fetchPaymentsByChittieId = (chittieId) =>
  db
    .ref('chittiePayments')
    .orderByChild('chittieId')
    .equalTo(chittieId)
    .once('value');

export const addDeletedAuction = (auctionId, values) =>
  db
    .ref('deletedAuctions')
    .push(values)
    .then(() => {
      db.ref('chittieAuction/' + auctionId)
        .remove();
    });
//REPORTS API

export const getAuction = () => db.ref('chittieAuction').once('value');

export const filterAuctionByChitId = (chitId) =>
  db.ref('chittieAuction/chitId' + chitId).once('value');

export const filterAuctionByChittyId = (value) =>
  db
    .ref('chittieAuction')
    .orderByChild('chitId_chittieId')
    .equalTo(value)
    .once('value');

export const filterChittiePaymentByChitId = (chitId) =>
  db.ref('chittiePayments/chitId' + chitId).once('value');

export const filterChittiePaymentByChittyId = (value) =>
  db
    .ref('chittiePayments')
    .orderByChild('chitId_chittieId')
    .equalTo(value)
    .once('value');

//DASHBOARD API
export const getDashboardCount = () => db.ref('dashboard').once('value');

export const removeDashboardCount = (id, childName) =>
  db.ref('dashboard/' + id).child(childName).transaction((data) => {
    return data - 1;
  });

export const addDashboardCount = (id, childName) =>
  db.ref('dashboard/' + id).child(childName).transaction((data) => {
    return data + 1;
  });

//VISITOR API
export const getVisitors = () => db.ref('visitors').once('value');

export const addVisitors = (values) => db.ref('visitors').push(values);

export const filterVisitorByName = (value) =>
  db
    .ref('visitors')
    .orderByChild('searchName')
    .startAt(value)
    .endAt(value + '\uf8ff')
    .once('value');

export const filterVisitorById = (value) =>
  db.ref('visitors/' + value).once('value');

export const updateVisitor = (id, values) =>
  db.ref('visitors/' + id).update(values);

export const fetchMinutes = () =>
  db
    .ref('chittieAuction')
    .orderByChild('minuteFiled')
    .equalTo(false)
    .once('value');

export const getCompletedChitties = (value) =>
  db
    .ref('chitties')
    .orderByChild('auctionsCompleted')
    .equalTo(value)
    .once('value');

//RECEIPT API
export const fetchReceiptNumber = () =>
  db.ref('receipts').once('value');

export const addReceiptNumber = (id, childName) =>
  db.ref('receipts/' + id).child(childName).transaction((data) => {
    return (data || 0) + 1;
  });

//PROFILE API
export const fetchProfileDetails = () =>
  db.ref('profile').once('value');

export const addProfileDetails = (values) =>
  db.ref('profile')
    .push(values)
    .then((snapshot) => {
      return { [snapshot.key]: values };
    });

export const updateProfile = (id, values) =>
  db.ref('profile/' + id)
    .update(values);



// WEBPACK FOOTER //
// ./src/firebase/db.js